import shareHeader from './shareHeader'
import shareFooter from './shareFooter'
import userinfoimg from './userinfoimg'
import downTip from './downTip'
import morerepeat from './morerepeat'
import shareSuccessBack from './shareSuccessBack'
export default {shareHeader,shareFooter,userinfoimg,downTip,morerepeat,shareSuccessBack}



// WEBPACK FOOTER //
// ./src/components/index.js